function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.01,
  fill: "#FFF",
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 18v4l.0035504.3068562C11.1665717 29.3448082 16.9228654 35 24 35s12.8334283-5.6551918 12.9964496-12.6931438L37 22v-4h2v4l-.0032178.3138282c-.160183 7.8047051-6.2814324 14.1450894-13.9959045 14.6533095L25 42h6v2H17v-2h6l.0001649-5.0327937c-7.7149632-.5077174-13.83675686-6.8483214-13.99694714-14.6533781L9 22v-4h2zM24 3c5.9787016 0 10.8433652 4.76976358 10.9962926 10.7115925L35 14v8c0 6.0751322-4.9248678 11-11 11-5.9787016 0-10.8433652-4.7697636-10.9962926-10.7115925L13 22v-8c0-6.07513225 4.9248678-11 11-11zm0 2c-4.6326577 0-8.4477983 3.50020676-8.9451047 8.0003032L21 13v2h-6v2h6v2h-6v2h6v2l-5.9449943.0006955C15.5527662 27.5003111 19.367685 31 24 31c4.632315 0 8.4472338-3.4996889 8.9449943-7.9993045L27 23v-2h6v-2h-6v-2h6v-2h-6v-2l5.9451047.0003032C32.4477983 8.50020676 28.6326577 5 24 5z",
  fill: "currentColor"
}));

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.63ae1819.svg";
export { ForwardRef as ReactComponent };